var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiAssistant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 77,
    viewBox: "0 0 78 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_23319_42557)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    width: 60,
    height: 60,
    rx: 30,
    fill: "url(#paint0_linear_23319_42557)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.0714,
    y: 1.07143,
    width: 57.8571,
    height: 57.8571,
    rx: 28.9286,
    stroke: "white",
    strokeWidth: 2.14286
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.0716,
    y: 25.1108,
    width: 27.8571,
    height: 17.6108,
    rx: 7.5974,
    fill: "#587E85"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.7166,
    cy: 33.7559,
    r: 3.20197,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.963,
    cy: 33.7559,
    r: 3.20197,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.8403,
    cy: 18.3865,
    r: 3.20197,
    fill: "#587E85"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.5594,
    y: 20.3079,
    width: 2.56158,
    height: 4.80296,
    fill: "#587E85"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_23319_42557",
    x: 9.53674e-7,
    y: 0,
    width: 78,
    height: 78,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_23319_42557"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_23319_42557",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23319_42557",
    x1: 9,
    y1: 0,
    x2: 69,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8ED5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9CF3D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiAssistant);
export default __webpack_public_path__ + "static/media/ai_assistant.d8e9a2a518c9f70aa2cfad1a7827722b.svg";
export { ForwardRef as ReactComponent };